"use client";
import React, { useState, useEffect } from "react";
import ConfirmInformation from "./components/ConfirmInformation";
import VerifyIdentitySuccess from "./components/VerifyIdentitySuccess";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { useSharedData } from "bossjob-remote/dist/hooks";
import { fetchAuthorizeData, fetchAuthorizeDataConfirm } from "store/services/newIndex";
const SingpassMain = () => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const pathname = usePathname();
  const [isVerify, setIsVerify] = useState(false);
  const searchParams = useSearchParams();
  const sgCode = searchParams?.get("showSingpassInfo");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [confirmData, setConfirmData] = useState(null);
  const dic = useSharedData("DICTIONARY");
  useEffect(() => {
    if (sgCode) {
      fetchAuthorizeData().then((res) => {
        setData(res?.data?.data || {});
        setOpen(true);
      });
    }
  }, [sgCode]);

  const handleClose = () => {
    router.replace(pathname);
    setOpen(false);
  };

  const handleSubmit = () => {
    setLoading(true);
    fetchAuthorizeDataConfirm()
      .then((res) => {
        setConfirmData(res?.data?.data || {});
        setOpen(false);
        setIsVerify(true);
      })
      .finally(() => setLoading(false));
  };

  const handleOk = () => {
    setIsVerify(false);
    setOpen(false);
    window.location.href = pathname;
  };

  const lang = {
    "singpass.verifyYourIdentity": "Verify Your Identity",
    "singpass.unlockMoreJobOpportunities":
      " Unlock more job opportunities by verifying your identity through Singpass.",
    "singpass.maximizeExposure": " Maximize Exposure",
    "singpass.verifiedCandidatesArePrioritized":
      " Verified candidates are prioritized in applications — stand out to top employers.",
    "singpass.browseExclusiveJobs": " Browse Exclusive Jobs",
    "singpass.verificationUnlocksAdditionalJob":
      " Verification unlocks additional job listings — more options just for you.",
    "singpass.doItLater": "Do it later",
    "singpass.verificationFailed": "Verification Failed",
    "singpass.confirmYourInformation": "Confirm your information",
    "singpass.myInfoIsCurrentlyUnavailable":
      " My info is currently unavailable, please try it again later",
    "singpass.NRIC": "NRIC/FIN",
    "singpass.principalName": "Principal Name",
    "singpass.residentialStatus": "Residential Status",
    "singpass.nationality": "Nationality/Citizenship",
    "singpass.passType": "Pass Type",
    "singpass.passStatus": "Pass Status",
    "singpass.passExpiryDate": "Pass Expiry Date",
    "singpass.specialReminder": "Special reminder：Data Source from Singpass",
    "singpass.submit": "Submit",
    "singpass.identityVerifiedSuccessfully": "Identity Verified Successfully!",
    "singpass.yourCurrentIdentity": "Your current identity is",
    "singpass.nowYouEnjoy": "Now you’ll enjoy",
    "singpass.priorityVisibilityToEmployers": "Priority visibility to employers for eligible jobs",
    "singpass.anExclusiveVerifiedBadge": "An exclusive verified badge on your profile",
    "singpass.higherChancesOfJobMatching": "Higher chances of job matching",
    "singpass.findJobsNow": "Find Jobs Now"
  };

  return (
    <>
      {open && (
        <ConfirmInformation
          open={open}
          onClose={handleClose}
          loading={loading}
          data={data}
          handleSubmit={handleSubmit}
          dic={dic?.singpass || {}}
        />
      )}

      {isVerify && (
        <VerifyIdentitySuccess
          open={isVerify}
          onClose={handleOk}
          confirmData={confirmData}
          dic={dic?.singpass || {}}
        />
      )}
    </>
  );
};

export default SingpassMain;
